module.exports = __webpack_public_path__ + "media/images/city/027-white-tower-of-thessaloniki-063c4cd0b9df83f4c6577dc361e64d38.svg";